"use client";

import { useState } from "react";
import { CircleHelp } from "lucide-react";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";
import Modal from "@/components/ui/Modal";

/** Короткая строка и иконка; пояснение открывается в модальном окне. */
export default function CompareEmptyHelpTooltip() {
  const t = useTranslations("ComparePage");
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div className="inline-flex max-w-[min(100%,14rem)] shrink-0 items-center justify-between gap-1.5 text-sm sm:max-w-none">
        <span className="truncate font-medium text-gray-900 dark:text-gray-100" title={t("emptyStatusLine")}>
          {t("emptyStatusLine")}
        </span>
        <button
          type="button"
          aria-haspopup="dialog"
          aria-expanded={modalOpen}
          aria-label={t("emptyTooltipAria")}
          className={cn(
            "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-gray-100 focus-visible:outline focus-visible:ring-2 focus-visible:ring-[#E63946]/35 dark:hover:bg-gray-800 dark:focus-visible:ring-[#E63946]/40",
          )}
          onClick={() => setModalOpen(true)}
        >
          <CircleHelp size={18} strokeWidth={2} aria-hidden />
        </button>
      </div>

      <Modal open={modalOpen} onClose={() => setModalOpen(false)} title={t("emptyModalTitle")} size="sm" closeOnBackdrop>
        <p className="m-0 text-pretty text-sm leading-relaxed text-gray-600 dark:text-gray-400">{t("emptyBody")}</p>
      </Modal>
    </>
  );
}
